module.exports = __webpack_public_path__ + "static/media/room2_3.d9265821.JPG";